import styled from 'styled-components';

const GetCompanyIdContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
`;

const FormSection = styled.div`
  flex: 2;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 20px 40px;
  border-right: 2px solid #d4d4d4;
  border-bottom: 2px solid #d4d4d4;
  border-collapse: collapse;
`;

const Title = styled.div`
  font-size: 27px;
  line-height: 37px;
  font-weight: 700;
  color: #000000;
`;

const InputSection = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin: 24px 0px;
`;

const DetailsOfInput = styled.div`
  flex: 1;
  margin-right: 25px;
  flex-direction: column;
  min-height: 49px;
  height: max-content;
  justify-content: center;
`;

const InputTilte = styled.div`
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
  color: #000000;
`;

const InputSubtitle = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  color: #b4b4b4;
`;

const InputFieldWithSubmit = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Input = styled.input`
  font-size: 16px;
  max-width: 275px;
  padding: 11px;
  font-weight: 400;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
  margin-bottom: 10px;
`;

const GetCompanyIdButton = styled.button`
  width: max-content;
  font-size: 19px;
  line-height: 26px;
  font-weight: 700;
  padding: 11px 26px;
  background-color: ${props => (props.loading ? '#eeeeee' : '#42ffbb')};
  box-shadow: 0px 2px 4px 0px rgba(129, 129, 129, 0.5);
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
`;

const ResultSection = styled.div`
  display: flex;
  flex: 1;
  border-right: 2px solid #d4d4d4;
  border-bottom: 2px solid #d4d4d4;
  min-width: 300px
  flex-direction: column;
  overflow: auto;
`;

const CompanyDetails = styled.div`
  padding: 21px;
  flex-direction: column;
  border-bottom: ${props => (props.hideBorder ? 'none' : '1px solid #d4d4d4')};
  word-break: break-word;
`;

const DetailTitle = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 6px;
`;

const DetailData = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  color: #000000;
  margin-bottom: ${props => props.margin};
`;

const LoaderContainer = styled.div`
  display: flex;
  padding: 20px 0px;
  justify-content: center;
  align-items: center;
`;

export {
  GetCompanyIdContainer,
  Title,
  FormSection,
  InputSection,
  DetailsOfInput,
  InputTilte,
  InputSubtitle,
  InputFieldWithSubmit,
  Input,
  GetCompanyIdButton,
  ResultSection,
  CompanyDetails,
  DetailTitle,
  DetailData,
  LoaderContainer
};



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GetCompanyId/styles.js